import { createAgendarConsultasCalculations } from '@atendimento/agenda/calculator-agendarConsulta'
import { createDecorator, Form, FormRenderProps } from 'components/form'
import { usePecField } from 'components/form/core/hooks/useField'
import { useFlags } from 'config/useFlagsContext'
import { AcessoCbo } from 'graphql/types.generated'
import { useServerTime } from 'hooks/useServerTime'
import { MetaPath, metaPath } from 'util/metaPath'

import { agendarConsultasValidator } from '../../validator/validator-agendamento'
import { AgendarConsultaSection } from './AgendarConsultaSection'
import { AgendarConsultaSectionModel } from './model-agendarConsultaAtendimento'

interface AgendarProximaConsultaFormProps {
  name: MetaPath<AgendarConsultaSectionModel>
  initialValues: AgendarConsultaSectionModel
  setIsFormOpen(isFormOpen: boolean): void
  cbosAcesso?: AcessoCbo[]
}

const meta = metaPath<AgendarConsultaSectionModel>()

const decorators = [createDecorator(...createAgendarConsultasCalculations(meta))]

export function AgendarProximaConsultaForm(props: Readonly<AgendarProximaConsultaFormProps>) {
  const { name, initialValues, setIsFormOpen, cbosAcesso } = props

  const { getServerTimeNow } = useServerTime()
  const { HORARIO_FINAL_AGENDAMENTO_ENABLED } = useFlags()

  const {
    input: { onChange },
  } = usePecField({ name })

  const handleSubmitForm = (agendamentoValues: AgendarConsultaSectionModel) => {
    onChange(agendamentoValues)
    setIsFormOpen(false)
  }

  const validator = agendarConsultasValidator(getServerTimeNow, HORARIO_FINAL_AGENDAMENTO_ENABLED, true)

  const renderForm = ({ handleSubmit }: FormRenderProps<AgendarConsultaSectionModel>) => (
    <AgendarConsultaSection
      name={meta}
      errorPath={name}
      isProximaConsulta
      setIsFormAgendarProximaConsultaOpen={setIsFormOpen}
      onSubmitFormAgendarProximaConsulta={handleSubmit}
      cbosAcesso={cbosAcesso}
      showHorarioFinal={HORARIO_FINAL_AGENDAMENTO_ENABLED}
    />
  )

  return (
    <Form<AgendarConsultaSectionModel>
      render={renderForm}
      initialValues={initialValues}
      decorators={decorators}
      validate={validator}
      onSubmit={handleSubmitForm}
    />
  )
}
